module.exports = __webpack_public_path__ + "img/button.3af367ce.svg";